import { h } from 'preact'

import FormInput from '../elements/FormInput'
import initializeForm from '../utilities/initializeForm'

import { formFields, formSchema } from './config'

import sharedStyles from '../sharedStyles.module.scss'
import { useState } from 'preact/hooks'
import ChartContainer from '../../charts/ChartContainer/ChartContainer'
import BarChart from '../../charts/BarChart'
import formatNumber from '../../../utilities/formatNumber'

function calculateYear(start, monthly, year, rate) {
  const monthlyReturn = rate / 100 / 12

  const num = Number(start) * Number(Math.pow(1 + monthlyReturn, year * 12))
  const num2 =
    (monthly * Number(Math.pow(1 + monthlyReturn, year * 12) - 1)) /
    monthlyReturn

  return num + num2
}

function renderChartData(formData) {
  const monthlyReturn = Number(formData.rateOfReturn) / 100 / 12
  const numberOfYears = Number(formData.retirementAge) - Number(formData.age)
  const months = numberOfYears * 12
  const assets = Number(formData.startingInvestment)
  const contributions = Number(formData.monthlyInvestment)
  const expectedSavings =
    assets * Math.pow(1 + monthlyReturn, months) +
    contributions * ((Math.pow(1 + monthlyReturn, months) - 1) / monthlyReturn)

  const data = []

  let i = 0

  while (i < numberOfYears) {
    data.push({
      year: i + 1,
      value: calculateYear(
        Number(formData.startingInvestment),
        Number(formData.monthlyInvestment),
        Number(i),
        Number(formData.rateOfReturn),
      ),
    })
    i++
  }

  return {
    data,
    numberOfYears,
    expectedSavings: Number(expectedSavings).toFixed(2),
  }
}

export default function RetirementForm({ formName }) {
  const [view, setView] = useState('form')
  const [data, setData] = useState(null)
  const { formValues, formErrors, handleInputChange, validateForm, resetForm } =
    initializeForm({
      initialValues: {
        age: '',
        retirementAge: '',
        monthlyInvestment: '',
        startingInvestment: '',
        rateOfReturn: '3',
      },
      formSchema,
    })

  function submit() {
    validateForm().then(validFormData => {
      setView('results')

      setData(renderChartData(validFormData))
    })
  }

  if (view === 'results') {
    return (
      <div>
        <p>
          At your current rate of savings, you will have{' '}
          <strong>${formatNumber(Number(data.expectedSavings))}</strong> at
          retirement.
        </p>
        <p>
          {data.numberOfYears} years @ {formValues.rateOfReturn}% rate of return
          (${formValues.monthlyInvestment}/month)
        </p>

        <ChartContainer
          edit={() => setView('form')}
          reset={() => {
            resetForm()
            setView('form')
            setData(null)
          }}
        >
          <BarChart data={data?.data || []} />
        </ChartContainer>
      </div>
    )
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        submit()
      }}
      className={sharedStyles.Form}
    >
      {Object.entries(formFields).map(([key, input]) => {
        const id = `${formName}-${key}`
        return (
          <FormInput
            key={id}
            id={id}
            identifier={key}
            input={input}
            error={formErrors?.[key]}
            value={formValues?.[key]}
            handleInputChange={handleInputChange}
          />
        )
      })}
      <div className={sharedStyles.SubmitContainer}>
        <button type="submit" className="button dark">
          Calculate
        </button>
      </div>
    </form>
  )
}
